module.exports = __webpack_public_path__ + "static/media/nab.15c5ae6e.png";